const styles = {
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
    },
    responsiveVideoWrapper: {
        width: '100%',
        height: '100%',
        // Cap native caption cue size (browser default scales with video height).
        sx: {'video::cue': {fontSize: '18px'}}
    },
    coverVideo: {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    }
}

export default styles
